import { Navigate } from "react-router-dom";

function ProtectedRoute({ children }) {

  try {

    // GET TOKEN
    const token =
      localStorage.getItem("token");

    // GET USER
    const user = JSON.parse(
      localStorage.getItem("user")
    );

    // NO TOKEN OR USER
    if (!token || !user) {

      localStorage.clear();

      return (
        <Navigate
          to="/"
          replace
        />
      );

    }

    return children;

  } catch (err) {

    console.log("AUTH ERROR:", err);

    localStorage.clear();

    return (
      <Navigate
        to="/"
        replace
      />
    );

  }

}

export default ProtectedRoute;